// Hidden content still has layout, so visible lazy images can be loaded before revealing it.
export async function waitForPageReady(root, doc = document, win = window) {
  const loaded = doc.readyState === 'complete'
    ? Promise.resolve()
    : new Promise(resolve => win.addEventListener('load', resolve, { once: true }));
  await Promise.all([loaded, doc.fonts?.ready]);
  await new Promise(resolve => win.requestAnimationFrame(resolve));
  const images = [...root.querySelectorAll('img')].filter(img => {
    const rect = img.getBoundingClientRect();
    return img.loading !== 'lazy' || (rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < win.innerHeight && rect.left < win.innerWidth);
  });
  await Promise.all(images.map(async img => {
    img.loading = 'eager';
    if (!img.complete) {
      await new Promise(resolve => {
        const finish = () => {
          img.removeEventListener('load', finish);
          img.removeEventListener('error', finish);
          resolve();
        };
        img.addEventListener('load', finish, { once: true });
        img.addEventListener('error', finish, { once: true });
        if (img.complete) finish();
      });
    }
    if (img.naturalWidth > 0 && img.decode) await img.decode().catch(() => {});
  }));
  // Paint the final font metrics and decoded images together with the page.
  await new Promise(resolve => win.requestAnimationFrame(resolve));
}
